let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("28EDH")).then(() => parcelRequire('Uq9Kn'));